import Text from 'components/Text/Text';
import React, { useContext, useEffect } from 'react';
import {
	IEditRestaurantContext,
	EditRestaurantContext,
} from '../../../../../editRestaurantState/editRestaurantContext';
import {
	IAndroidWatchesFormContext,
	AndroidWatchesFormContext,
} from '../androidWatchesFormState/androidWatchesFormContext';
import { Form } from 'antd';
import { ImportantMessagesSelect } from './components/ImportantMessagesSelect';
import { InformationMessagesSelect } from './components/InformationMessagesSelect';
import { BtnBlock } from './components/BtnBlock';
import { preventDefaultForEnterKey } from 'utils/helpers';
import style from './InputFields.module.scss';

export const InputFields: React.FC = () => {
	const { restaurantId } = useContext<IEditRestaurantContext>(EditRestaurantContext);
	const {
		setImportantMessages,
		setInformationMessages,
		setDataForSubmit,
		changeTypeOfModalWindow,
		importantMessages,
		informationMessages,
	} = useContext<IAndroidWatchesFormContext>(AndroidWatchesFormContext);
	const [form] = Form.useForm();

	useEffect(() => {
		form.setFieldsValue({ importantMessages, informationMessages });
	}, [importantMessages, informationMessages]);

	const submit = async () => {
		setDataForSubmit({
			restaurantID: restaurantId,
			data: {
				importantMessages,
				informationMessages,
			},
		});
		changeTypeOfModalWindow('toConfirmSubmit');
	};

	return (
		<div className={style.container} data-test="InputFields">
			<Form form={form} name="basic" onFinish={submit} onKeyPress={preventDefaultForEnterKey} layout="vertical">
				<div className={style.fieldsWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="messagesHeading"
						theme="secondary"
						size="l"
						weight="bold"
						display="inline"
					/>
					<div className={style.row}>
						<ImportantMessagesSelect setImportantMessages={setImportantMessages} />
						<div className="flex-1" />
						{/*<InformationMessagesSelect setInformationMessages={setInformationMessages} />*/}
					</div>
				</div>
				<BtnBlock />
			</Form>
		</div>
	);
};
